import { render } from "./InfoLocker.vue?vue&type=template&id=610c4b54&scoped=true&ts=true"
import script from "./InfoLocker.vue?vue&type=script&lang=ts"
export * from "./InfoLocker.vue?vue&type=script&lang=ts"

import "./InfoLocker.vue?vue&type=style&index=0&id=610c4b54&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-610c4b54"]])

export default __exports__